import React, { memo } from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { WhiteBackgroundProps } from './models';

const WhiteBackground = styled(({ className }: WhiteBackgroundProps) => {
  return (
    <div {...{ className }}>
      <div className="element element-1" />
      <div className="element element-2" />
      <div className="element element-3" />
      <div className="element element-4" />
      <div className="element element-5" />
      <div className="element element-6" />
    </div>
  );
})`
  ${styles.WhiteBackground}
`;

const MemoBackground = memo(WhiteBackground);
export { MemoBackground as WhiteBackground };
